import $ from "jquery";
import Vars from "../../../vars";
import Action from "../../classes/Action";
import Validation from "../../classes/Validation";
import Request from "../../../components/request";
import Modal from "../../../components/Modal";
import Utils from "../../../components/utils";
import DropzoneScoial from "../../dropzone/social-vk";

class Vk {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $content : $(),
        $create  : $(),
        $edit    : $(),
        $change  : $(),
        $export  : $(),
        $params  : $(),
        $modal   : $(),
        $form    : $()
    };

    _const = {
        entities : 'socials',
        entity   : 'social'
    };

    _args = {
        page : '',
        id   : 0
    };

    _utils = {
        validation : {}
    };

    _state = {
        items    : {},
        item     : {},
        dropzone : {}
    };

    _actions = {
        activate : {
            title: 'Активация экспорта предложений в сообщество'
        },
        deactivate : {
            title: 'Деактивация экспорта предложений в сообщество'
        },
        remove : {
            title: 'Удаление сообщества'
        },
        confirmation : {
            title: 'это сообщество'
        },
        done : {
            activate : function(args) {
                let self = args.self;
                self._state.item.is_active   = args[self._const.entity].is_active;

                self._elems.$content.html(Utils.renderProfileTemplate('social-vk', {
                    [self._const.entity] : self._state.item,
                    counts               : self._state.counts
                }));

                self._bindElements();
                self._bindUI();

                self._bindActions();
            },
            deactivate : function(args) {
                let self = args.self;
                self._state.item.is_active   = args[self._const.entity].is_active;

                self._elems.$content.html(Utils.renderProfileTemplate('social-vk', {
                    [self._const.entity] : self._state.item,
                    counts               : self._state.counts
                }));

                self._bindElements();
                self._bindUI();

                self._bindActions();
            }
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page = args.page;
        self._args.id   = args.id || self._args.id;
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _setDropzone = (args) => {
        let self = this;

        loader.increase();
        Request.send({
            path: '/api/socials/vk/' + self._state.item.id + '/images',
            method: 'POST',
            done: function (response) {
                loader.decrease();

                self._state.dropzone.items = DropzoneScoial.get({
                    item     : self._state.item,
                    entities : self._const.entities,
                    response : response
                });
                self._state.dropzone.entity = self._state.item;

                args.done && args.done();
            }
        });
    };

    _getImages = () => {
        let self = this;

        const network = 'vk';
        loader.increase();

        Request.send({
            path: 		'/api/socials/' + network + '/' + self._state.item.id + '/images',
            method: 	'POST',
            done: function(response) {
                loader.decrease();

                (function() {
                    let dropzone = new Dropzone('#social-vk-params-form .dropzone.is-social-image', {
                        url: '/api/socials/vk/' + self._state.item.id + '/?api_token=' + auth.user.api_token,

                        addRemoveLinks: 	true,
                        paramName: 			'image',
                        thumbnailWidth: 	78,
                        thumbnailHeight: 	78,
                        maxFilesize: 		10,
                        maxFiles: 			20,
                        timeout:            180000,

                        dictDefaultMessage: 	'' //'Чтобы загрузить изображения, выберите или просто перетащите их в это поле',
                    });

                    dropzone.processing = 0;

                    dropzone.on('processing', function(file) {
                        (dropzone.processing == 0) && $('#osocial-vk-params-form .button').prop('disabled', true);
                        ++dropzone.processing;
                    });

                    dropzone.on('complete', function(file) {
                        --dropzone.processing;
                        (dropzone.processing == 0) && $('#social-vk-params-form .button').prop('disabled', false);
                        var response = file.xhr ? JSON.parse(file.xhr.response) : null;
                        var $file = $(file._removeLink).parent();

                        if (response && response.error) {
                            return;
                        }

                        if (!file.plan) {
                            file.plan = response ? response.plan : null;
                        }

                        var selected = $('#social-vk-params-form input[name="compilation[image]"]').val();

                        if (file.plan) {
                            var path = (file.plan.path_to_extra_large != '') ? file.plan.path_to_extra_large : file.plan.path_to_original;
                            $file.find('.dz-image').css('background-image', 'url(\'/' + (file.plan.path_to_small != '' ? file.plan.path_to_small : file.plan.path_to_original) + '\')');
                            $file.find('.dz-image').data('path', path);
                            $file.find('.dz-image img').remove();

                            if(selected == path)
                                $file.find('.dz-image').addClass('selected');
                        }
                    });

                    response.images.forEach(function(plan) {
                        var file = { name: '', size: 1 };
                        dropzone.emit('addedfile', file);
                        file.plan = plan;
                        dropzone.emit('processing', file);
                        dropzone.emit('complete', file);
                        dropzone.files.push(file);
                    });

                    response.plans.forEach(function(plan) {
                        var file = { name: '', size: 1 };
                        dropzone.emit('addedfile', file);
                        file.plan = plan;
                        dropzone.emit('processing', file);
                        dropzone.emit('complete', file);
                        dropzone.files.push(file);
                    });

                    $('#social-vk-params-form .dropzone.is-social-image .dz-image').on('click', function(){
                        var image = $(this);
                        if(image.hasClass('selected')) {
                            image.removeClass('selected');
                            $('#social-vk-params-form input[name="compilation[image]"]').val('');
                        }
                        else {
                            $('#social-vk-params-form .dropzone.is-social-image .dz-image').each(function(){
                                $(this).removeClass('selected');
                            });
                            image.addClass('selected');

                            $('#social-vk-params-form input[name="compilation[image]"]').val(image.data('path'));
                        }
                    });
                })();

                return response.plans;
            }
        });
    };

    _initModal = () => {
        let self = this;

        loader.increase();

        Request.send({
            queue: [
                {
                    path: '/api/socials/vk/' + self._args.id
                },
                {
                    path: '/api/socials/options'
                }
            ],
            done: function(response, extraResponse){
                loader.decrease();
                Utils.scrollToTop();

                self._state.item = response[self._const.entity];
                let buildings    = response.buildings;
                let sections     = response.sections;
                let ad_types     = response.ad_types;
                let options      = extraResponse.options;
                let objects      = options.objects;
                let companies    = options.companies;

                self._elems.$modal = new Modal({
                    title : Object.keys(self._state.item).length ? 'Редактирование данных сообщества' : 'Добавление нового сообщества',
                    content : Utils.renderProfileTemplate('social-vk-form', {
                        social    : Object.keys(self._state.item).length ? self._state.item : null,
                        objects   : objects,
                        companies : companies,
                        buildings : buildings,
                        sections  : sections,
                        ad_types  : ad_types
                    }),
                    confirm : function(args) {
                        self._bindSubmit(args);
                    },
                    closing : function(args) {
                        self._elems.$form = $();
                        self._elems.$modal = $()
                    },
                    closingConfirmation: true
                });

                self._elems.$form = self._elems.$modal.find('form');

                self._setValidation();
                self._bindGeneralActions({
                    objects : objects
                });
            }
        });
    };

    _initCreateModal = () => {
        let self = this;

        loader.increase();

        Request.send({
            path: '/api/socials/options',
            done: function(response){
                loader.decrease();
                Utils.scrollToTop();

                let options      = response.options;
                let objects      = options.objects;
                let companies    = options.companies;

                self._elems.$modal = new Modal({
                    title : Object.keys(self._state.item).length ? 'Редактирование данных сообщества' : 'Добавление нового сообщества',
                    content : Utils.renderProfileTemplate('social-vk-form', {
                        social    : null,
                        objects   : objects,
                        companies : companies,
                        buildings : null,
                        sections  : null,
                        ad_types  : null
                    }),
                    confirm : function(args) {
                        self._bindSubmit(args);
                    },
                    closing : function(args) {
                        self._elems.$form = $();
                        self._elems.$modal = $()
                    },
                    closingConfirmation: true
                });

                self._elems.$form = self._elems.$modal.find('form');

                self._setValidation();
                self._bindGeneralActions({
                    objects : objects
                });
            }
        });
    };
    
    _initParamsModal = () => {
        let self = this;

        self._setDropzone({
            done : function() {
                let $modal = new Modal({
                    title   : 'Редактирование параметров сообщества',
                    content : Utils.renderProfileTemplate('social-vk-params-form', {
                        [self._const.entity] : self._state.item
                    }),
                    confirm : function(args) {
                        self._bindParamsSubmit(args);
                    },
                    dropzone : self._state.dropzone,
                    closingConfirmation: true
                });

                let $form = $modal.find('form');
                if (!$form.length) return;

                if ($form.find('[data-name="compilation[union]"] .checkbox').hasClass('checked')) {
                    $form.find('[data-name="compilation[name]"]').show();
                    $form.find('[data-name="compilation[name]"] input').attr('required', 'required');
                    $form.find('[data-name="compilation[name]"] input').removeAttr('disabled');

                    $form.find('[data-name="compilation[images]"]').show();
                    $form.find('[data-name="compilation[images]"] input').removeAttr('disabled');
                }
                else {
                    $form.find('[data-name="compilation[name]"]').hide();
                    $form.find('[data-name="compilation[name]"] input').removeAttr('required');
                    $form.find('[data-name="compilation[name]"] input').attr('disabled', 'disabled');

                    $form.find('[data-name="compilation[images]"]').hide();
                    $form.find('[data-name="compilation[images]"] input').attr('disabled', 'disabled');
                }

                $form.find('[data-name="compilation[union]"] .checkbox').on('change', function(){
                    if ($(this).hasClass('checked')) {
                        $form.find('[data-name="compilation[name]"]').show();
                        $form.find('[data-name="compilation[name]"] input').attr('required', 'required');
                        $form.find('[data-name="compilation[name]"] input').removeAttr('disabled');

                        $form.find('[data-name="compilation[images]"]').show();
                        $form.find('[data-name="compilation[images]"] input').removeAttr('disabled');
                    }
                    else {
                        $form.find('[data-name="compilation[name]"]').hide();
                        $form.find('[data-name="compilation[name]"] input').removeAttr('required');
                        $form.find('[data-name="compilation[name]"] input').attr('disabled', 'disabled');

                        $form.find('[data-name="compilation[images]"]').hide();
                        $form.find('[data-name="compilation[images]"] input').attr('disabled', 'disabled');
                    }
                });
            }
        });
    };

    _bindParamsSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        Request.send({
            path: 		'/api/socials/vk/' + self._state.item.id + '/params',
            method: 	'POST',
            data: 		$form.serialize(),
            done: function(response) {
                loader.decrease();

                if (response.error) {
                    if (response.error.type == 'validation') {
                        let fields = {
                            compilation_name: 'compilation_name'
                        };
                        Object.keys(response.error.fields).forEach(function (field_name) {
                            $form.find('.form-field[data-name="social[' + fields[field_name] + ']"]').each(function () {
                                $(this).addClass('error');

                                $(this).find('.form-field__message').each(function () {
                                    $(this).removeClass('hidden').html(response.error.fields[field_name].join('<br />'));
                                });
                            });
                        });
                    }
                }
                else {
                    $modal.trigger('close');

                    self._state.item.updated_at = response[self._const.entity].updated_at;
                    self._state.item.is_actual  = response[self._const.entity].is_actual;

                    self._elems.$content.html(Utils.renderProfileTemplate('social-vk', {
                        [self._const.entity] : self._state.item,
                        counts               : self._state.counts
                    }));

                    self._bindElements();
                    self._bindUI();
                }
            }
        });
    };

    _bindSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let errors = $form.find('.form-field.error').length;
        if (errors) return;

        loader.increase();
        Request.send({
            path: '/api/socials/vk/' + (Object.keys(self._state.item).length ? self._state.item.id + '/edit' : 'create'),
            method: 'POST',
            data: $form.serialize(),
            done: function (response) {
                loader.decrease();

                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return
                }

                $modal.trigger('close');

                if (self._args.page == Vars.page.item) {
                    self._state.item   = response[self._const.entity];

                    self._elems.$content.html(Utils.renderProfileTemplate('social-vk', {
                        [self._const.entity] : self._state.item,
                        counts               : self._state.counts
                    }));

                    self._bindElements();
                    self._bindUI();
                }
                else {
                    window.location.href = '#socials/' + response.network + '/' + response.social.id;
                }
            }
        });
    };

    _bindGeneralActions = (args) => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._bindAdvancedActions();

        let i = 0;
        self._elems.$form.find('.form-field__wrapper').each(function(){
            if (i == 0) $(this).addClass('first');
            i++;
        });

        let $btnObjectAdd  = self._elems.$form.find('.js-profile-social-object-add');
        let objCount       = self._elems.$form.find('.form-field__wrapper.first select[name="social[object_ids][]"] option').length - 1;
        let objShowedCount = self._elems.$form.find('.form-field__wrapper').length;

        if (objCount == objShowedCount) $btnObjectAdd.hide();

        $btnObjectAdd.click(function(e){
            e.preventDefault();
            let $btn = $(this);

            $btn.before(
                Utils.renderProfileTemplate('social-object', {
                    social  : null,
                    objects : args.objects
                })
            );

            self._bindAdvancedActions();

            let objShowedCount = self._elems.$form.find('.form-field__wrapper').length;
            if (objCount == objShowedCount) $btn.hide();
        });
    };

    _bindAdvancedActions = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._elems.$form.find('.js-profile-social-object-delete').on('click', function(e) {
            e.preventDefault();
            let $link = $(this);
            let $parent = $link.parents('.form-field__wrapper');

            $parent.remove();
            self._elems.$form.find('.js-profile-soical-object-add').show();
            return false;
        });

        self._elems.$form.find('select.new[name="social[object_ids][]"]').change(function(){
            let $select = $(this);
            $select.removeClass('new');
            const val = parseInt($select.val());
            let $parent = $select.parents('.form-field');
            let $wrapper = $select.parents('.form-field__wrapper');
            $parent.removeClass('error');
            $parent.find('.form-field__message').addClass('hidden').html('');
            $wrapper.find('.form-field[data-name="social-buildings"]').hide();
            $wrapper.find('.form-field[data-name="social-adtypes"]').hide();

            let flag1, flag2, flag3 = false;
            $wrapper.find(
                'input[data-name="social[auto_adding_new]"],' +
                'input[data-name="social[types]"],' +
                'input[data-name="social[ad_types]"]')
                .each(function(){
                    if ($(this).attr('disabled') == 'disabled')
                        $(this).addClass('disabled');

                    $(this).attr('disabled', 'disabled');
                    $(this).parent().removeClass('checked');
                });
            $wrapper.find('input[data-name="social[auto_adding_new]"]').each(function(){
                if (!$(this).hasClass('disabled')) $(this).removeAttr('disabled');
            });
            $wrapper.find('input[data-name="social[types]"], input[data-name="social[ad_types]"]').each(function(){
                let $input = $(this);
                if (!$input.parent().hasClass('disabled')) {
                    $input.removeAttr('disabled');
                    $input.parent().addClass('checked');
                }
            });

            $wrapper.find('.form-field[data-name="social-buildings"] > ul').each(function(){
                let $ul = $(this);
                $ul.removeClass('active').hide();
                $ul.find(
                    'input[name="object[building_ids][]"],' +
                    'input[name="object[section_ids][]"],' +
                    'input[data-name="social[building_all]"]')
                    .each(function(){
                        if ($(this).attr('disabled') == 'disabled')
                            $(this).addClass('disabled');

                        $(this).attr('disabled', 'disabled');
                        $(this).parent().removeClass('checked');
                    });
                if (parseInt($ul.data('complex-id')) == val && $(this).children('ul > li').length){
                    $wrapper.find('.form-field[data-name="social-buildings"]').show();
                    $wrapper.find('.form-field[data-name="social-adtypes"]').show();

                    $wrapper.find('.form-field[data-name="social-adtypes"] input[data-name="social[types]"]').each(function(){
                        $(this).attr('name', 'social' + val + '[types][]')
                    });
                    $wrapper.find('.form-field[data-name="social-buildings"] input[data-name="social[auto_adding_new]"]').each(function(){
                        $(this).attr('name', 'social' + val + '[auto_adding_new]')
                    });
                    $wrapper.find('.form-field[data-name="social-buildings"] input[data-name="social[building_all]"]').each(function(){
                        $(this).attr('name', 'social' + val + '[building_all]')
                    });
                    $wrapper.find('.form-field[data-name="social-adtypes"] input[data-name="social[ad_types]"]').each(function(){
                        $(this).attr('name', 'social' + val + '[ad_types][]')
                    });

                    $ul.addClass('active').show();
                    $ul.find('input[data-name="social[building_all]"]').removeAttr('disabled');
                    $ul.find('input[name="object[building_ids][]"], input[name="object[section_ids][]"]').each(function(){
                        let $input = $(this);
                        if (!$input.parent().hasClass('disabled')) {
                            $input.removeAttr('disabled');
                            $input.parent().addClass('checked');
                        }
                        if ($input.next('ul') !== undefined && $(this).next('ul').length){
                            let $subUl = $input.next('ul');
                            if ($subUl.find('input[name="object[section_ids][]"]').length == $subUl.children('li.disabled').length) {
                                $subUl.parent().removeClass('checked').addClass('disabled');
                                $input.attr('disabled', 'disabled');
                            }
                            else
                                flag3 = true;
                        }
                    });

                    if ($ul.find('input[name="object[building_ids][]"]').length == $ul.children('li.disabled').length) flag2 = true;

                    flag1 = true;
                }
            });

            let objects = [];
            self._elems.$form.find('select[name="social[object_ids][]"]').each(function(){
                let $sel = $(this);
                const value = $sel.val();
                let $par = $sel.parents('.form-field');
                if (objects.indexOf(value) != -1){
                    $par.addClass('error');
                    $par.find('.form-field__message').removeClass('hidden').html('Нельзя выбрать один и тот же комплекс дважды. Выберите, пожалуйста, другой');
                }
                objects[value] = value;
            });

            if ($select.children('option[value="' + val  + '"]').data('active') == 0){
                $parent.addClass('error');
                $parent.find('.form-field__message').removeClass('hidden').html('Выбранный комплекс неактивен. Выберите другой комплекс или <a' +
                    ' href="/profile#objects/' + val + '"' +
                    ' target="_blank">активируйте его</a>')
            }
            else if (!flag1 || flag2){
                $parent.addClass('error');
                $parent.find('.form-field__message').removeClass('hidden').html('В выбранном комплексе отсутствуют дома c активными секциями. Выберите другой комплекс или <a' +
                    ' href="/profile#objects/' + val + '"' +
                    ' target="_blank">активируйте дома и секции</a>')
            }
            else if (!flag3){
                $parent.addClass('error');
                $parent.find('.form-field__message').removeClass('hidden').html('Отсутствуют активные секции. Чтобы выбрать дом, необходимо <a target="_blank">активировать секции</a>')
            }
        });
    };

    _bindActions = () => {
        let self = this;

        if (self._args.page == Vars.page.list) return;

        new Action({
            id       : self._state.item.id,
            actions  : self._actions,
            entities : 'vk',
            entity   : 'vk',
            prefix   : 'socials',
            self     : self
        });
    };

    _bindCreateMax = () => {
        let self = this;

        const count = parseInt(self._elems.$create.data('count'));
        const max   = parseInt(self._elems.$create.data('max'));

        if (count < max && max != 0) return true;

        if (max == 0) {
            new Modal({
                title: ifacade.constants.messages.socials.access.max.title,
                content: Utils.renderProfileTemplate('info', {
                    message : ifacade.constants.messages.socials.access.start.message,
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Хорошо'
                        },
                        two : null
                    }
                }),
                confirm : function(args) {
                    args.modal && args.modal.trigger('close');
                }
            });

            return false;
        }

        new Modal({
            title: ifacade.constants.messages.socials.access.max.title,
            content: Utils.renderProfileTemplate('info', {
                message : ifacade.constants.messages.socials.access.max.message.replace('%max%', max),
                buttons : {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Хорошо'
                    },
                    two : null
                }
            }),
            confirm : function(args) {
                args.modal && args.modal.trigger('close');
            }
        });

        return false;
    };

    _bindCreate = () => {
        let self = this;

        if (!self._elems.$create.length) return;

        self._elems.$create.unbind('click').on('click', function(e){
            e.preventDefault();
            if ($(this).hasClass('disabled')) return;
            if (!self._bindCreateMax()) return;

            self._initCreateModal();
        });
    };

    _bindEdit = () => {
        let self = this;

        if (!self._elems.$edit.length) return;

        self._elems.$edit.unbind('click').on('click', function(e){
            e.preventDefault();
            self._initModal();
        });
    };

    _bindChange = () => {
        let self = this;

        if (!self._elems.$change.length) return;

        self._elems.$change.unbind('click').on('click', function(e){
            e.preventDefault();

            loader.increase();

            if ($(this).hasClass('do')){
                self._elems.$export.show();

                const groupId = $(this).prev('.select').children('select').val();

                Request.send({
                    path: 	'/api/socials/vk/' + self._state.item.id + '/group/set/' + groupId,
                    method: 'POST',

                    done: function(response) {
                        loader.decrease();

                        if (response.error) {
                            console.error(response.error);
                            return;
                        }

                        self._state.item   = response[self._const.entity];

                        self._elems.$content.html(Utils.renderProfileTemplate('social-vk', {
                            [self._const.entity] : self._state.item,
                            counts               : self._state.counts
                        }));

                        self._bindElements();
                        self._bindUI();
                    }
                });
            }
            else {
                self._elems.$export.hide();

                let vkUser = self._state.item.user.vk_user.filter(function(user){
                    return user.current;
                }).pop();

                self._elems.$content.find('.js-groups-empty').addClass('hidden');
                self._elems.$content.find('.js-groups').addClass('hidden');

                Request.send({
                    path: '/api/socials/vk/user' + vkUser.id + '/groups/',
                    done: function (response) {
                        loader.decrease();
                        Utils.scrollToTop();

                        if (response.error) {
                            console.log('Ошибка');
                            return;
                        }

                        if (!response.length) {
                            self._elems.$content.find('.js-groups-empty').removeClass('hidden');
                        }
                        else {
                            self._elems.$content.find('.js-groups').removeClass('hidden');
                            let $select = self._elems.$content.find('.js-groups').find('select');
                            response.forEach(function(group){
                                let $option = $('<option/>').val(group.id).text(group.name);
                                if (self._state.item.vk_id == group.id) $option.attr('selected', 'selected');
                                $select.append($option);
                            });
                        }
                    }
                });
            }
        });
    };

    _bindParams = () => {
        let self = this;

        if (!self._elems.$params.length) return;

        self._elems.$params.unbind('click').on('click', function (e) {
            e.preventDefault();

            loader.increase();
            Request.send({
                path: '/api/socials/vk/' + self._state.item.id,
                done: function(response){
                    loader.decrease();
                    Utils.scrollToTop();

                    self._state.item = response[self._const.entity];

                    self._initParamsModal();
                }
            });
        });
    };

    _bindExport = () => {
        let self = this;

        if (!self._elems.$export.length) return;

        self._elems.$export.on('click', function(e) {
            e.preventDefault();
            self._elems.$content.find('.js-profile-activate').trigger('click');
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = $('.content');
        if (!self._elems.$content.length) return;

        self._elems.$create  = self._elems.$content.find('.js-profile-social-vk-create');
        self._elems.$edit    = self._elems.$content.find('.js-profile-edit');
        self._elems.$change  = self._elems.$content.find('.js-profile-social-vk-group-select');
        self._elems.$export  = self._elems.$content.find('.js-profile-social-vk-export');
        self._elems.$params  = self._elems.$content.find('.js-profile-social-vk-params');
    };

    _bindUI = () => {
        let self = this;

        if (!self._elems.$content.length) return;

        self._bindCreate();
        self._bindEdit();
        self._bindChange();
        self._bindExport();
        self._bindParams();
        self._bindActions();
    };

    _list = () => {
        let self = this;

        Request.send({
            queue: [
                {
                    path: '/api/socials/vk',
                },
                {
                    path: '/api/socials/counts',
                },
                {
                    path: '/api/accesses?only=' + self._const.entities
                }
            ],
            done: function(response, extraResponse, extraResponse1) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items  = response[self._const.entities] ? response[self._const.entities] : {};
                self._state.counts = extraResponse.counts;

                const accesses     = extraResponse1.accesses;

                if (!accesses[self._const.entities].enabled) {
                    new Modal({
                        title: ifacade.constants.messages.socials.access.base.title,
                        content: Utils.renderProfileTemplate('info', {
                            message : ifacade.constants.messages.socials.access.base.message,
                            buttons : {
                                one : {
                                    class : 'confirm button--edit',
                                    title : 'Хорошо'
                                },
                                two : null
                            }
                        }),
                        confirm : function(args) {
                            args.modal && args.modal.trigger('close');
                            window.location.href = '/profile';
                        }
                    });

                    return false;
                }

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Выгрузка в социальные сети',
                            href  : '#socials'
                        },
                        {
                            title : 'Товары ВКонтакте'
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate('social-vk-list', {
                    breadcrumbs            : self._state.breadcrumbs,
                    [self._const.entities] : self._state.items,
                    counts                 : self._state.counts,
                    accesses               : accesses
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _item = () => {
        let self = this;
        loader.increase();

        Request.send({
            queue: [
                {
                    path: '/api/socials/vk/' + self._args.id,
                },
                {
                    path: '/api/socials/counts',
                }
            ],
            done: function(response, extraResponse) {
                loader.decrease();
                Utils.scrollToTop();

                if (response.error) {
                    window.location.href = '#socials/vk';
                    return;
                }

                self._state.item   = response[self._const.entity];
                self._state.counts = extraResponse.counts;

                self._elems.$content.html(Utils.renderProfileTemplate('social-vk', {
                    [self._const.entity] : self._state.item,
                    counts               : self._state.counts
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;
        self._bindElements();
        if (!self._elems.$content.length) return;

        if (self._args.page === Vars.page.list) {
            self._list();
        }
        else if (self._args.page == Vars.view.item) {
            self._item();
        }
    };
}

export default Vk;